/**
 * Pre-compiled localized messages for Pagination component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import paginationMessages_en from "./intl/en";
import paginationMessages_de from "./intl/de";
import paginationMessages_es from "./intl/es";
import paginationMessages_fr from "./intl/fr-FR";
import paginationMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const paginationMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(paginationMessages_en),
  de: normalizeMessages(paginationMessages_de),
  es: normalizeMessages(paginationMessages_es),
  "fr-FR": normalizeMessages(paginationMessages_fr),
  "pt-BR": normalizeMessages(paginationMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Pagination component
 */
export type PaginationMessageKey =
  | "currentPage"
  | "goToNextPage"
  | "goToPreviousPage"
  | "itemsPerPage"
  | "itemsPerPageText"
  | "ofTotalPages"
  | "page"
  | "pagination";
